import Flux from 'lib/flux';
import _ from 'underscore';
import I from 'immutable';
import NavigationConstants from 'constants/navigation';

const NavigationStore = Flux.createStore({
  name: 'navigation',

  getInitialState() {
    return {
      screensStack: [],
      screensStackLast: null,
    };
  },

  getScreensStackTop(state) {
    return state
      .get('screensStack')
      .last()
      .setIn(['stackIndex'], state.get('screensStack').count() - 1);
  },

  canTransitionBack() {
    return this.state.get('screensStack').size > 1;
  },

  actions: [
    [
      NavigationConstants.TRANSITION_TO,
      function (Screen, props) {
        const descriptor = I.fromJS({
          component: Screen,
          props,
        });

        this.state = this.state.withMutations((map) =>
          map
            .updateIn(['screensStack'], (list) => list.push(descriptor))
            .set('screensStackLast', this.getScreensStackTop(map))
        );
      },
    ],

    [
      NavigationConstants.TRANSITION_BACK,
      function () {
        if (this.state.get('screensStack').count() <= 1) {
          throw new Error('Attempted to pop the last screen on the stack.');
        }

        this.state = this.state.withMutations((map) =>
          map
            .updateIn(['screensStack'], (list) => list.pop())
            .set('screensStackLast', this.getScreensStackTop(map))
        );
      },
    ],
  ],
});

export default NavigationStore;
